export const visit = (vm, at) => {
at({ "en": { "videoReports": { "videoViewsChart": { "header": "Video views", "views": "Views", "viewDate": "View date" }, "videoRetentionChart": { "header": "Video retention", "videoSelectorLabel": "Video:", "viewsPerSecond": "Views (per second)", "duration": "Duration" } } } });
};